import { createSlice } from "@reduxjs/toolkit";
import axios from "../../lib/axios";
import { toast } from "react-toastify";

const initialState = {
  data: [],
  loading: false,
  error: null,
};

const paymentMethod = createSlice({
  name: "paymentmethod",
  initialState,
  reducers: {
    requestStart: (state) => {
      state.loading = true;
      state.error = null;
    },
    requestSuccess: (state, action) => {
      state.data = action.payload;
      state.loading = false;
      state.error = null;
    },
    requestFailure: (state, action) => {
      state.loading = false;
      state.error = action.payload;
      state.data = [];
    },
  },
});
// const baseUrl = "https://staging.kumeo.com";

export const { requestStart, requestSuccess, requestFailure } =
  paymentMethod.actions;

export const GetPaymentMethods = () => async (dispatch) => {
  try {
    dispatch(requestStart());

    const res = await axios.get("/private/paymentmethods/active");

    if (res.data) {
      dispatch(requestSuccess(res.data));
    }
  } catch (error) {
    const errorMessage = error?.response?.data?.message || String(error);
    toast.error(errorMessage);
    dispatch(requestFailure(errorMessage));
  }
};

export default paymentMethod.reducer;
